<template>
  <div v-bind:load="addHeaderClass()" :class="{ animateBackground: this.animateOnload}">
    <Navigation></Navigation>
    <component :key="blok._uid" v-for="blok in blok.body" :blok="blok" :is="blok.component"></component>
    <Footer></Footer>
  </div>
</template>

<script>
export default {
  props: ["blok"],
  data() {
    return {
      animateOnload: false
    };
  },
  methods: {
    addHeaderClass() {
      var vw = this;
      setTimeout(function() {
        vw.animateOnload = true;
      }, 100);
      return this.animateOnload;
    },
    toggleBodyClass(className) {
      const el = document.body;
      el.classList.add(className);
    },
    changeBgOnScroll() {
      var vsry = window.scrollY;
      var bodyHeight = document.querySelector(".bodyclass").offsetHeight;
      var addBottomScrolledClass =
        bodyHeight - window.innerHeight - window.innerHeight / 2;

      if (vsry <= window.innerHeight / 2) {
        document.querySelector(".bodyclass").classList.remove("scrolledeBg");
      }
      if (vsry >= window.innerHeight / 2) {
        document.querySelector(".bodyclass").classList.add("scrolledeBg");
        document
          .querySelector(".bodyclass")
          .classList.remove("scrolledeBottomBg");
      }
      if (vsry >= addBottomScrolledClass) {
        document.querySelector(".bodyclass").classList.add("scrolledeBottomBg");
      }
    }
  },
  mounted() {
    this.toggleBodyClass("bodyclass", "mb-0");
  },
  created() {
    window.addEventListener("scroll", this.changeBgOnScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.changeBgOnScroll);
  }
};
</script>
